import React, { useEffect } from "react";
import styles from '../styles/amountField.module.scss'
import Input from "@/wmCompoments/input";
import { useFormContext } from "react-hook-form";
import { useGetBalanceData } from "@/api/request";
import { useTranslation } from "react-i18next";

interface Props {
    name: string
    selectName: string
}

const AmountField = (props: Props) => {
    const { t } = useTranslation('transferCenter')
    
    const { name, selectName } = props;

    const {
        register,
        setValue,
        watch,
        trigger,
        clearErrors,
        formState: { errors },
    } = useFormContext();

    const value = watch(name);
    const selectValue = watch(selectName);
    const { data } = useGetBalanceData()
    const userBalance = Number(data?.centerWalletBalance) ?? 0;

    // console.log('selectValue==', selectValue)

    const handleInputChange = (v: string) => {
        // 只允许数字和小数点（保留两位小数）
        const numeric = v.replace(/[^\d.]/g, '');
        setValue(name, numeric);
        trigger(name);
    };

    // 取场馆用户余额
    const maxValue = selectValue?.left?.id === 0 ? userBalance : selectValue?.left?.money;

    const handleSetMax = () => {
        setValue(name, maxValue.toString());
        trigger(name);
    };


    useEffect(() => {
        clearErrors(name)
        setValue(name, '');
    }, [name, selectValue])



    return (
        <div className={styles.wrapper}>
            <div className={styles.label}>{t('transferAmount')}</div>

            <div className={styles.inputWrapper}>
                <Input
                    {...register(name, {
                        required: t('enterTransferAmount'),
                        validate: (val: string) => {
                            const num = parseFloat(val);
                            if (isNaN(num)) return t('enterNumber');
                            if (Number(val) == 0) return t('transferAmountNotZero');
                            if (Number(val) > Number(maxValue)) return `${selectValue?.left?.zhName}${t('insufficientBalance')}`
                            return true;
                        }
                    })}
                    value={value}
                    onChange={handleInputChange}
                    placeholder={t('enterTransferAmount')}
                    suffix={
                        <div className={styles.suffix}>
                            <div>{t('rmb')}</div>
                            <div onClick={handleSetMax} className={styles.maxBtn}>{t('maximum')}</div>
                        </div>
                    }
                />
            </div>

            {errors[name] && (
                <div className={styles.errorText}>{errors[name]?.message?.toString()}</div>
            )}
        </div>
    );
};

export default AmountField;
